/**
 * Header Logic Engine Script
 */
document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('[data-site-header]');
  
  // 1. Sticky Scroll Behavior
  if (header && header.getAttribute('data-sticky') === 'true') {
    window.addEventListener('scroll', () => {
      if (window.scrollY > 20) {
        header.classList.add('is-scrolled');
      } else {
        header.classList.remove('is-scrolled');
      }
    }, { passive: true });
  }

  // 2. Desktop Dropdown Menu Open/Close Hover Listeners
  const navItems = document.querySelectorAll('.site-header__nav-item.has-dropdown');
  navItems.forEach(item => {
    item.addEventListener('mouseenter', () => {
      item.classList.add('is-open');
      const link = item.querySelector('.site-header__nav-link');
      if (link) link.setAttribute('aria-expanded', 'true');
    });
    item.addEventListener('mouseleave', () => {
      item.classList.remove('is-open');
      const link = item.querySelector('.site-header__nav-link');
      if (link) link.setAttribute('aria-expanded', 'false');
    });
  });

  // 3. Desktop Image Grid Changer on Hover
  document.querySelectorAll('[data-dropdown]').forEach(dropdown => {
    const links = dropdown.querySelectorAll('.site-header__dropdown-nav-link');
    const cards = dropdown.querySelectorAll('.site-header__dropdown-card');

    function setActiveCard(index) {
      cards.forEach((card, i) => {
        if (i === parseInt(index)) {
          card.classList.add('is-active');
        } else {
          card.classList.remove('is-active');
        }
      });
    }

    // Set first card active by default on load
    setActiveCard(0);

    links.forEach(link => {
      link.addEventListener('mouseenter', () => {
        const targetIndex = link.getAttribute('data-index');
        setActiveCard(targetIndex);
      });
    });

    const navList = dropdown.querySelector('.site-header__dropdown-nav');
    if (navList) {
      navList.addEventListener('mouseleave', () => {
        setActiveCard(0);
      });
    }
  });

  // 4. Mobile Menu Drawer Toggle Functionality
  const menuToggle = document.querySelector('[data-menu-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  const menuClose = document.querySelector('[data-mobile-menu-close]');
  const menuOverlay = document.querySelector('[data-mobile-menu-overlay]');

  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', () => {
      mobileMenu.removeAttribute('hidden');
      // Brief delay to allow CSS transitions to trigger smoothly
      setTimeout(() => {
        document.body.classList.add('mobile-menu-open');
        mobileMenu.classList.add('is-open');
        menuToggle.setAttribute('aria-expanded', 'true');
      }, 10);
    });
  }

  function closeMobileMenu() {
    if (mobileMenu) {
      document.body.classList.remove('mobile-menu-open');
      mobileMenu.classList.remove('is-open');
      if (menuToggle) menuToggle.setAttribute('aria-expanded', 'false');
      
      setTimeout(() => {
        mobileMenu.setAttribute('hidden', '');
      }, 320); // Matches transition slide duration
    }
  }

  if (menuClose) menuClose.addEventListener('click', closeMobileMenu);
  if (menuOverlay) menuOverlay.addEventListener('click', closeMobileMenu);

  // 5. Mobile Submenu Accordion Collapsing
  const submenuToggles = document.querySelectorAll('[data-mobile-submenu-toggle]');
  submenuToggles.forEach(toggle => {
    toggle.addEventListener('click', () => {
      const item = toggle.closest('.mobile-menu__item');
      const submenu = item.querySelector('[data-mobile-submenu]');
      const isExpanded = toggle.getAttribute('aria-expanded') === 'true';

      if (isExpanded) {
        toggle.setAttribute('aria-expanded', 'false');
        item.classList.remove('is-open');
        if (submenu) submenu.style.height = '0px';
      } else {
        toggle.setAttribute('aria-expanded', 'true');
        item.classList.add('is-open');
        if (submenu) {
          // Set to scrollHeight so it unfolds smoothly regardless of link count
          submenu.style.height = submenu.scrollHeight + 'px';
        }
      }
    });
  });
  window.addEventListener('resize', () => {
  if (window.innerWidth >= 990) {
    const mobileMenu = document.querySelector('.mobile-menu');
    if (mobileMenu) {
      mobileMenu.classList.remove('is-open');
    }
    document.body.classList.remove('mobile-menu-open');
  }
});
});